// extracted by mini-css-extract-plugin
export default {"title":"ffb5c58ee2","bld":"_0fe1775729"};